export default "__VITE_ASSET__D3s5fIjS__"